var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoletoEExtratoSensiaBig = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 4.6665C15.1203 4.6665 4.66699 15.1198 4.66699 27.9998C4.66699 40.8798 15.1203 51.3332 28.0003 51.3332C40.8803 51.3332 51.3337 40.8798 51.3337 27.9998C51.3337 15.1198 40.8803 4.6665 28.0003 4.6665ZM28.0003 46.6665C17.7103 46.6665 9.33366 38.2898 9.33366 27.9998C9.33366 17.7098 17.7103 9.33317 28.0003 9.33317C38.2903 9.33317 46.667 17.7098 46.667 27.9998C46.667 38.2898 38.2903 46.6665 28.0003 46.6665ZM30.077 25.8998C25.9237 24.5232 23.917 23.6598 23.917 21.4665C23.917 19.0865 26.507 18.2232 28.1403 18.2232C31.197 18.2232 32.317 20.5332 32.5737 21.3498L36.2603 19.7865C35.9103 18.7598 34.347 15.3298 30.0537 14.5832V11.6665H25.9703V14.6065C19.9037 15.9132 19.857 21.2565 19.857 21.5132C19.857 26.8098 25.107 28.3032 27.6737 29.2365C31.3603 30.5432 32.9937 31.7332 32.9937 33.9732C32.9937 36.6098 30.5437 37.7298 28.3737 37.7298C24.127 37.7298 22.9137 33.3665 22.7737 32.8532L18.9003 34.4165C20.3703 39.5265 24.2203 40.9032 25.947 41.3232V44.3332H30.0303V41.4398C31.2437 41.2298 37.077 40.0632 37.077 33.9265C37.1003 30.6832 35.677 27.8365 30.077 25.8998Z",
    fill: "#86AA63"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoletoEExtratoSensiaBig);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/boleto_e_extrato_sensia_big.6abfb99f2c345e1951b144bf32e97b6b.svg";